import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=21877c17&"
import script from "./Room.vue?vue&type=script&lang=js&"
export * from "./Room.vue?vue&type=script&lang=js&"
import style0 from "./Room.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports